<template>
  <v-widget title="Lịch sử khiếu nại">
    <template v-slot:widget-content>
      <v-data-table
        :headers="paymentComplainHeader"
        :items="order.OrderComplains"
        :mobile-breakpoint="100"
        :footer-props="{ 'items-per-page-options': [10, 20, 30, 40, 50] }"
        :items-per-page="10"
        class="border"
      >
        <template v-slot:item="{ item }">
          <tr>
            <td>{{ item.ID }}</td>
            <td class="text-end font-weight-bold">{{ item.Amount | currency }}</td>
            <td>{{ item.ComplainText }}</td>
            <td>{{ item.CreatedDate | display_date }}</td>
            <td>
              <v-chip label small :color="item.Status | complain_type_color" text-color="white">{{ item.Status | complain_type }}</v-chip>
            </td>
            <td class="text-center">
              <v-btn v-if="complainRole" small color="primary" @click="gotoComplainDetail(item.ID)">Chi tiết</v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
    </template>
  </v-widget>
</template>

<script>
import VWidget from "@/components/VWidget";
import { complain_type, complain_type_color } from "@/commons/hpod";

export default {
  name: "TabComplainHistory",
  components: {
    VWidget
  },
  filters: {
    complain_type,
    complain_type_color
  },
  props: {
    order: {
      type: Object,
      required: true
    },
    paymentComplainHeader: {
      type: Array,
      required: true
    },
    complainRole: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    gotoComplainDetail(id) {
      let routeData = this.$router.resolve({
        path: `/khieu-nai/${id}`,
        params: {
          Pid: id,
          title: `Chi tiết khiếu nại (#${id})`
        }
      });
      window.open(routeData.href, "_blank");
    }
  }
};
</script>
